import { Settings, User } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface SidebarFooterProps {
	isOpen: boolean;
}

/**
 * The gear opens `/settings` (DOP-266). It used to open a Logout confirmation
 * modal — a settings icon whose only behaviour was signing you out, and the
 * only place logout lived. Logout is now an action on the settings page, which
 * is where a user goes looking for it.
 */
const SidebarFooter: React.FC<SidebarFooterProps> = ({ isOpen }) => {
	const { user } = useAuth();

	return (
		<div className="p-4 border-t border-gray-200">
			<div className="flex items-center justify-between gap-2 whitespace-nowrap">
				<div className="flex items-center space-x-3 min-w-0 flex-1">
					<div className="w-8 h-8 bg-[#F6FAFF] rounded-full flex items-center justify-center flex-shrink-0">
						<User className="w-4 h-4 text-[#19213D]" />
					</div>
					<span
						className={`text-sm font-medium text-[#19213D] truncate transition-opacity duration-200 ${isOpen ? "opacity-100" : "opacity-0"}`}
					>
						{user?.full_name || "Account"}
					</span>
				</div>
				<Link
					to="/settings"
					aria-label="Settings"
					title="Settings"
					className={`p-2 hover:bg-gray-100 rounded-lg transition-all duration-200 flex-shrink-0 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
				>
					<Settings className="w-4 h-4 text-[#666F8D]" />
				</Link>
			</div>
		</div>
	);
};

export default SidebarFooter;
